import Regions from './Regions';

export default Regions;



// WEBPACK FOOTER //
// ./src/pages/Regions/index.ts